import { render, staticRenderFns } from "./dataContent.vue?vue&type=template&id=6984f022&scoped=true"
import script from "./dataContent.vue?vue&type=script&lang=js"
export * from "./dataContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6984f022",
  null
  
)

export default component.exports